// extracted by mini-css-extract-plugin
export var bodySections = "_41-8";
export var gray = "_41-7";
export var green = "_41-4";
export var iconContainer = "_41-9";
export var iconWidgetContainer = "_41-1";
export var phoneIcon = "_41-2";
export var red = "_41-5";
export var statusDot = "_41-3";
export var widgetContainer = "_41-0";
export var yellow = "_41-6";